/** BookingsFillBarSection — the segmented fill bar + "X of Y seats open" +
 *  the check-in guests-in subtext, extracted from BookingsCard (BON-490) so
 *  the card's own render function stays under the size cap. */
import { SegmentedFillBar, type FillSegment } from '../../primitives';

export function BookingsFillBarSection({
  segments,
  capacity,
  highlightTone,
  occupiedSeats,
  seatsOpen,
  showCheckedIn,
  checkedInSeats,
  confirmedAttendees,
}: {
  segments: FillSegment[];
  capacity: number;
  highlightTone: FillSegment['tone'] | null;
  occupiedSeats: number;
  seatsOpen: number;
  showCheckedIn: boolean;
  checkedInSeats: number;
  confirmedAttendees: number;
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <SegmentedFillBar
        segments={segments}
        total={capacity}
        highlightTone={highlightTone}
        ariaLabel={`${occupiedSeats} of ${capacity} seats occupied`}
      />
      <div style={{ fontSize: 11.5, color: 'var(--nb-subtle)' }} data-testid="seats-open">
        {seatsOpen} of {capacity} seats open
      </div>
      {showCheckedIn && (
        <div style={{ fontSize: 11.5, color: 'var(--nb-subtle)' }} data-testid="checked-in-subtext">
          {checkedInSeats} / {confirmedAttendees} guests in
        </div>
      )}
    </div>
  );
}
